import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IRecuperarEmpresasService } from 'src/app/pages/configuracion/maestros/empresas/services/ports/i-recuperar-empresas-service';
import { FiltroBasico, Filtros } from 'src/app/shared/models/filtros';
import { EmpresasModel } from '../models/empresas-model';
import { OrdenColumna } from 'src/app/shared/models/orden-columna';

@Injectable({
  providedIn: 'root'
})
export class DatosEmpresasService {

  empresas: EmpresasModel[] = [];

  constructor(@Inject('RecuperaEmpresas') private datosEmpresa: IRecuperarEmpresasService) {}

  public getEmpresas(filtros: FiltroBasico[], pageNumber:number, orden?: OrdenColumna): Observable<EmpresasModel[]>{
    return this.datosEmpresa.getEmpresas(filtros, pageNumber, orden)
      .pipe(
        map((resp:any) => {
          this.empresas = resp
          return this.empresas
        })
      )
  }

  guardaEmpresa(objetoEmpresa: EmpresasModel):Observable<void>{
    return this.datosEmpresa.guardaEmpresa(objetoEmpresa)
  }

  deleteEmpresa(objetoEmpresa: EmpresasModel):Observable<void>{
    return this.datosEmpresa.deleteEmpresa(objetoEmpresa)
  }

  checkSiCodigoEmpresaExiste(empresa: EmpresasModel): boolean{
    let indexCodigo = this.empresas.findIndex(x=> x.codigoEmpresa == empresa.codigoEmpresa)
    if(indexCodigo>-1){
      let indexCif = this.empresas.findIndex(x=> x.cif == empresa.cif)
      if(indexCif>-1 && indexCodigo == indexCif) return false
      else return true
    }else return false
  }

}
